import { render, staticRenderFns } from "./examReviewDialog.vue?vue&type=template&id=8366a2c4&scoped=true&"
import script from "./examReviewDialog.vue?vue&type=script&lang=js&"
export * from "./examReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./examReviewDialog.vue?vue&type=style&index=0&id=8366a2c4&scoped=true&lang=css&"
import style1 from "./examReviewDialog.vue?vue&type=style&index=1&lang=css&"
import style2 from "./examReviewDialog.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8366a2c4",
  null
  
)

export default component.exports